import "../styles/Footer.css"

function Footer() {
  return (
    <footer className="combined-footer">
      {/* Primary Footer */}
      <section className="footer-container" aria-label="Footer Navigation">
        <div className="forms">
          <div className="footer-logo">
            <p>Lu - Fit Personal Training</p>
          </div>
        </div>

        <nav className="socials" aria-label="Footer Navigation Sections">
          <div className="footer-links">
            <div>
              <h4>Explore</h4>
              <ul>
                <li><a href="/#services">Our Services</a></li>
                <li><a href="/#rates">Price</a></li>
                <li><a href="/#about-us">Meet Your Trainer</a></li>
                <li><a href="/#contact-section">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4>Client Info</h4>
              <ul>
                <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
                <li><a href="/refund-policy">Refund Policy</a></li>
              </ul>
            </div>
            <div>
              <h4>Get in Touch</h4>
              <address>
                <ul>
                  <li><a href="tel:+27211234567">Phone: +27 21 123 4567</a></li>
                  <li><a href="mailto:info@lu-fit.co.za">Email: info@lu-fit.co.za</a></li>
                  <li><a href="/location">Cape Town, Western Cape</a></li>
                </ul>
              </address>
            </div>
            <div>
              <h4>Programs</h4>
              <ul>
                <li><a href="/#services">Weight Loss</a></li>
                <li><a href="/#services">Muscle Building</a></li>
                <li><a href="/#services">Online Coaching</a></li>
                <li><a href="/#services">Custom Plans</a></li>
              </ul>
            </div>
          </div>
        </nav>
      </section>

      {/* Secondary Footer */}
      <section className="footer-second" aria-label="Footer Legal Links">
        <ul>
          <li><a href="/terms-and-conditions" className="footer-link">TERMS & CONDITIONS</a></li>
          <li><a href="/privacy-policy" className="footer-link">PRIVACY POLICY</a></li>
          <li><a href="/refund-policy" className="footer-link">REFUND POLICY</a></li>
        </ul>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} Lu - Fit. All rights reserved.
        </div>
      </section>
    </footer>
  );
}

export default Footer;
